import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';
import { catchError, map, of } from 'rxjs';
import { environment } from '../../../../environments/environment';
import type {
  BlogRepository,
  RecordViewResponse,
  ViewCountEntry,
} from '../../domain/repositories/blog.repository';

/**
 * HTTP adapter for {@link BlogRepository}.
 *
 * Thin layer on top of HttpClient for blog view-count operations.
 * Error handling (silent fallback) lives here, matching the original
 * behaviour from BlogService. No caching — that belongs in the view layer.
 */
@Injectable({ providedIn: 'root' })
export class HttpBlogRepository implements BlogRepository {
  private readonly http = inject(HttpClient);
  private readonly blogApiBase = `${environment.apiUrl}/blog/posts`;

  public recordView(slug: string): Observable<RecordViewResponse> {
    return this.http
      .post<RecordViewResponse>(`${this.blogApiBase}/${encodeURIComponent(slug)}/view`, {})
      .pipe(catchError(() => of<RecordViewResponse>({ slug, view_count: 0 })));
  }

  public getAllViewCounts(): Observable<ViewCountEntry[]> {
    return this.http.get<readonly ViewCountEntry[]>(`${this.blogApiBase}/views`).pipe(
      map((entries) => [...entries]),
      catchError(() => of([] as ViewCountEntry[])),
    );
  }
}
